// system_admin: 1, admin: 2, client: 3, company: 4

export enum RoleType {
  SYSTEM_ADMIN = 'system_admin',
  ADMIN = 'admin',
  CLIENT = 'client',
  PARTNER = 'company',
}
